
import ArticlesList from "../components/articles/article-list";
import FounderResource from "../components/portfolio/founder-resources";
import Banner from "../components/ui-components/banner";
import HomePortfolio from "../components/ui-components/portfolio";
import { fetchPortfolioPage } from "../services/api";
// import SeoHead from '../components/SeoHead.jsx';
const PortfolioPage=({lang})=>{

    return(
        <>
         {/* <SeoHead slug="portfolio" lang={lang} /> */}
        <Banner  fetchData={fetchPortfolioPage} lang={lang} />
        <HomePortfolio limit={null} lang={lang}   showLink={false}/>
        {/* <ArticlesList lang={lang} variant="blue"/> */}
        {/* <FounderResource lang={lang}/> */}
        </>
    )
}

export default PortfolioPage;